import React, { useEffect, useMemo, useRef, useState } from "react";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";

import {
  entityFilter,
  getFilteredAndPaginatedEntities,
  getPaginationOptions,
  headerSortingClasses,
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  Pagination
} from "../../../../../../../../_metronic/_partials/controls";
import { useDeploymentJobsUIContext } from "../DeploymentJobsUIContext";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../_redux/DeploymentJobs/DeploymentJobsAction";
import { SearchText } from "../../../../../../../../utils/SearchText";
import { AutoServingTable } from "../../../../../../../../utils/AutoServingTable";
import { Col } from "reactstrap";
import {fetchCompanies} from "../../../../../../../../utils/commonFunction";
import ReactSelectDropDownCommon from "../../../../../../../../utils/SuperAdmin/ReactSelectDropDownCommon";
import {fetchDeployedJobs, fetchDeploymentJobs} from "../../../../_redux/DeploymentJobs/DeploymentJobsAction";
import CustomizedButtons from "../../../../../../../../utils/SuperAdmin/CustomizedButtons";

export function DeploymentJobTable() {
  const deploymentJobsUIContext = useDeploymentJobsUIContext();

  const deploymentJobsUIProps = useMemo(() => {
    return {
      ...deploymentJobsUIContext,
      openNewDeploymentJobDialog: deploymentJobsUIContext.openNewDeploymentJobDialog,
    };
  }, [deploymentJobsUIContext]);

  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  // Table columns
  const columns = [
    {
      dataField: "id",
      text: "Index",
      style: {
        minWidth: "55px"
      }
    },
    {
      dataField: "deployment_job_rtsp_details.user_details.company.company_name",
      text: "Company",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "deployment_job_rtsp_details.model_details.model_name",
      text: "Model",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openNewDeploymentJobDialog:
          deploymentJobsUIProps.openNewDeploymentJobDialog,
        openViewDeploymentJobDialog:
          deploymentJobsUIProps.openViewDeploymentJobDialog,
        // openStartDeploymentJobBtnClick:
        //   deploymentJobsUIProps.openStartDeploymentJobBtnClick
      },
      style: { minWidth: "152px" }
    }
  ];

  const { currentState } = useSelector(
    state =>
      (() => {
        return { currentState: state.deploymentJobs };
      })(),
    shallowEqual
  );

  const { entities, listLoading } = currentState;
  const [filterEntities, setFilterEntities] = useState(entities);
  const searchInput = useRef("");
  let currentItems = getFilteredAndPaginatedEntities(
    filterEntities || entities,
    deploymentJobsUIProps.queryParams
  );

  const filterDeploymentJobs = e => {
    const searchStr = e?.target?.value || searchInput.current.value;
    const keys = [
      "id",
      "image_size",
      "iou_threshold",
      "confidence_threshold",
      "model_details.model_name",
      "deployment_type.deployment_type_name",
      "user_details.company_name"
    ];
    currentItems = entityFilter(
      entities || filterEntities,
      searchStr,
      keys,
      deploymentJobsUIProps.queryParams,
      setFilterEntities
    );
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const loadCompanies = async () => {
      await fetchCompanies(setCompanyOptions, setSelectedCompany);
    };
    loadCompanies();


  }, []);


  useEffect(() => {
    if (selectedCompany?.value) {
      dispatch(fetchDeployedJobs(selectedCompany.value))
          .then((jobs) => {
            if (jobs.length > 0) {
              console.log("Fetched jobs for local use:", jobs.length);
              setFilterEntities(jobs);
            }else {
              console.log("Fetched jobs for local use: 00", jobs.length);
              setFilterEntities([]);
            }
          }).catch((error) => {
            setFilterEntities([]);
            console.error("Error fetching deployment jobs:", error);
      });
    }
  }, [selectedCompany, dispatch]);



  useEffect(() => {
    filterDeploymentJobs();
    //eslint-disable-next-line
  }, [entities]);

  const handleChangeCompany = (option) => {
    setSelectedCompany(option);
  }

  return (

      <Card>
        <CardHeader title="Deployment Jobs Data">
          <CardHeaderToolbar>
            <div className="d-flex align-items-center gap-3">
              <div style={{ minWidth: "200px" }} className="mr-3">
                <SearchText
                    reference={searchInput}
                    onChangeHandler={filterDeploymentJobs}
                />
              </div>

              <CustomizedButtons
                  title="Add Deployment Job"
                  color="primary"
                  className="mr-3"
                  submit={deploymentJobsUIProps.openNewDeploymentJobDialog}
              />
              <div style={{ minWidth: "180px" }}>
                <ReactSelectDropDownCommon
                    isSearchable={true}
                    placeholder="Select Company"
                    value={selectedCompany}
                    onChange={handleChangeCompany}
                    options={companyOptions}
                />
              </div>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <>

            <PaginationProvider
                pagination={paginationFactory(
                    getPaginationOptions(
                        filterEntities?.length,
                        deploymentJobsUIProps.queryParams
                    )
                )}
            >
              {({ paginationProps, paginationTableProps }) => {
                return (
                    <Pagination
                        isLoading={listLoading}
                        paginationProps={paginationProps}
                    >
                      <AutoServingTable
                          columns={columns}
                          items={filterEntities}
                          tableChangeHandler={deploymentJobsUIProps.setQueryParams}
                          paginationTableProps={paginationTableProps}
                      />
                    </Pagination>
                );
              }}
            </PaginationProvider>
          </>
        </CardBody>
      </Card>

  );
}
